import React, { useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function StudentProfile() {
  const { user, refresh, formatApiError } = useAuth();
  const [form, setForm] = useState({
    name: user?.name || "",
    phone: user?.phone || "",
    college: user?.college || "",
    skills: user?.skills || "",
  });
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put("/me/profile", form);
      await refresh();
      toast.success("Profile updated");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <DashboardLayout>
      <h1 className="heading text-2xl font-bold">Profile</h1>
      <p className="text-sm text-slate-500 mt-1">Manage your personal information.</p>
      <form onSubmit={save} className="mt-6 max-w-xl bg-white rounded-2xl border border-slate-200 p-6 space-y-4">
        <div>
          <label className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Email</label>
          <input value={user?.email || ""} disabled className="mt-1 w-full px-3 py-2.5 rounded-lg border border-slate-300 bg-slate-50 text-slate-500" />
        </div>
        {[
          ["Full Name", "name"],
          ["Phone", "phone"],
          ["College", "college"],
          ["Skills", "skills"],
        ].map(([l, k]) => (
          <div key={k}>
            <label className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">{l}</label>
            <input
              value={form[k]}
              onChange={(e) => setForm({ ...form, [k]: e.target.value })}
              className="mt-1 w-full px-3 py-2.5 rounded-lg border border-slate-300 focus:border-brand outline-none"
              data-testid={`profile-${k}-input`}
            />
          </div>
        ))}
        <button type="submit" disabled={saving} className="bg-brand hover:bg-[#172b66] disabled:opacity-60 text-white font-semibold rounded-lg px-6 py-2.5 flex items-center gap-2" data-testid="profile-save-button">
          {saving && <Loader2 size={16} className="animate-spin" />} Save Changes
        </button>
      </form>
    </DashboardLayout>
  );
}
